import { render } from "./RelatedCard.vue?vue&type=template&id=ef194c4c"
import script from "./RelatedCard.vue?vue&type=script&lang=js"
export * from "./RelatedCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__